import { getLink } from '../../../utils/utils';

import monumento from '../../images/monumento_de_zamenhof.jpg';
import author from './author';

const content = {
  esp: (
    `
      <div class="poem monumento-poem">
        <p class="poem-block mb-3">
          Arde laboris skulptist’ por vidigi animon de l’ viro,<br/>
          Kiu donacis al ni lingvon komunan por Ter’.<br/>
          Ankaŭ l’ anim’ de l’ skulptist’ al la sama ideo impetis,<br/>
          Ambaŭ strebis al cel’ nobla de l’ interkonsent’.
        </p>

        <p class="poem-block mb-3">
          Vi, kiu staras en kort’ antaŭ l’ busto de l’ homo sublima,<br/>
          Venis vi kiel turist’, kiu gapas al la vidindaĵ’?<br/>
          Aŭ eĉ aŭdis vi ion pri l’ homo kaj faro?<br/>
          Sed ĉu vi mem agis sincere por bon’?<br/>
          Flagris en via anim’ flamo de l’ am’ al homaro?<br/>
          Faris vi ion por Hom’, sincere kaj sen memador’?<br/>
          Se ne okazis por vi tia ŝanco en vivo sencela,<br/>
          Vin ne koncernu l’ afer’ kaj strebado al monda fratec’.
        </p>

        <p class="poem-block mb-3">
          Staras modeste en kort’ monumento malnova,<br/>
          Restas la revo pri l’ voj’, sed la vojon forviŝas la temp’…<br/>
          Iru, turisto, rigardi al la vidindaĵoj!<br/>
          Estas montrita la voj’. Sed la vojo ne estas por vi.
        </p>
        <div class="image">
          <img src=${monumento} alt="homo staras apud la monumento de Zamenhof" />
        </div>
      </div>
    `
  )
}

const itemName = {
  esp: 'Al la monumento de L. Zamenhof en Odessa'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;


 

 
